import Vue from 'vue';
import Router from 'vue-router';
import Watershed from '@/pages/Watershed';
import Streamflow from '@/pages/Streamflow';
import GroundwaterLevel from '@/pages/GroundwaterLevel';
import GroundwaterQuality from '@/pages/GroundwaterQuality';
import SurfaceWaterQuality from '@/pages/SurfaceWaterQuality';
import Climate from '@/pages/Climate';
import ShortUrlHandler from '@/pages/ShortUrlHandler';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/watershed',
        },
        {
            path: '/watershed',
            name: 'Watershed',
            component: Watershed,
            meta: {
                pageId: 'watershed',
                titleTag: 'Kootenay Boundary Water Tool - Watershed',
                toolHeader: 'Kootenay Boundary Water Tool - Watershed',
            },
        },
        {
            path: '/streamflow',
            name: 'Streamflow',
            component: Streamflow,
            meta: {
                pageId: 'streamflow',
                titleTag: 'BC Water Tool - Streamflow & Water Levels',
                toolHeader: 'BC Water Tool - Streamflow & Water Levels',
            },
        },
        {
            path: '/groundwater-level',
            name: 'GroundwaterLevel',
            component: GroundwaterLevel,
            meta: {
                pageId: 'groundwaterlevel',
                titleTag: 'BC Water Tool - Groundwater Levels',
                toolHeader: 'BC Water Tool - Groundwater Levels',
            },
        },
        {
            path: '/groundwater-quality',
            name: 'GroundwaterQuality',
            component: GroundwaterQuality,
            meta: {
                pageId: 'groundwaterquality',
                titleTag: 'BC Water Tool - Groundwater Quality',
                toolHeader: 'BC Water Tool - Groundwater Quality',
            },
        },
        {
            path: '/surface-water-quality',
            name: 'SurfaceWaterQuality',
            component: SurfaceWaterQuality,
            meta: {
                pageId: 'surfacewaterquality',
                titleTag: 'BC Water Tool - Surface Water Quality',
                toolHeader: 'BC Water Tool - Surface Water Quality',
            },
        },
        {
            path: '/climate',
            name: 'Climate',
            component: Climate,
            meta: {
                pageId: 'climate',
                titleTag: 'BC Water Tool - Climate',
                toolHeader: 'BC Water Tool - Climate',
            },
        },
        // interceptor route for saved state short URLs
        {
            path: '/saved/:shortUrl',
            component: ShortUrlHandler,
            meta: {
                pageId: 'shorturlhandler',
            },
        },
    ],
});

// change document title on route change
router.beforeEach((to, from, next) => {
    document.title = to.meta.titleTag || 'BC Water Tool';
    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js